export default {
  /**
   * Set individual staff away list items.
   *
   * @param state
   * @param items
   */
  setIndividualStaffAwayList(state, items) {
    console.log("Items : ", items);

    state.items = items;
  },

  /**
   * Set individual staff filters.
   *
   * @param state
   * @param filters
   */
  setIndividualStaffAwayListFilters(state, filters) {
    console.log("Filters", filters);

    state.filters = filters;
  },

  /**
   * Set individual staff away list pagination.
   *
   * @param state
   * @param pagination
   */
  setIndividualStaffAwayListPagination(state, pagination) {
    console.log("Items : ", pagination);

    state.pagination = pagination;
  },

  /**
   * Set current page.
   *
   * @param state
   * @param page
   */
  setIndividualStaffAwayListPage(state, page) {
    console.log("Page : ", page);

    state.pagination.current_page = page;
  },
};
